export const INPUT_CONTENT = {
  LOCATION: {
    label: 'Where do you plan to live?',
    tooltip: '',
  },
  PURCHASE_PRICE: {
    label: 'Home price',
    tooltip: 'Your target home price.',
  },
  DOWN_PAYMENT: {
    label: 'Down payment',
    tooltip: 'The cash payment you pay upfront when buying a home.',
  },
  ANNUAL_INTEREST_RATE: {
    label: 'Mortgage interest rate',
    tooltip: 'Your mortgage rate for a fixed-rate loan.',
  },
  LOAN_TERM: {
    label: 'Loan term',
    tooltip: 'The amount of time you have to pay back the loan.',
  },
  MONTHLY_RENT: {
    label: 'Comfortable monthly rent',
    tooltip: '',
  },
  PROPERTY_TAX_RATE: {
    label: 'Property tax rate',
    tooltip:
      'To estimate this, we use the average property tax rate for your state.',
  },
  HOA_DUES: {
    label: 'Monthly HOA fees',
    tooltip:
      'Homeowners’ association fees are common for condos and townhomes, and less likely for single-family homes.',
  },
  HOME_INSURANCE: {
    label: `Homeowner's insurance`,
    tooltip:
      'Homeowners insurance is required for most loans. It’s purchased annually as a percentage of the home price.',
  },
  MAINTAINANCE_FEE: {
    label: 'Home repairs',
    tooltip:
      'The annual amount you’ll pay for repairing your home. It’s estimated as a percentage of your home price.',
  },
  RENOVATION_FEES: {
    label: 'Renovations',
    tooltip:
      'The annual amount you expect to pay for home renovations. It’s estimated as a percentage of your home price.',
  },
  INCOME_TAX_RATE: {
    label: 'Marginal income tax rate',
    tooltip:
      'Marginal tax rate varies based on your income bracket. We assumed a default of 25%.',
  },
  RENTERS_INSURANCE: {
    label: `Renter's insurance`,
    tooltip:
      'Renter’s insurance is not a required cost, but it covers your personal possessions against fire, theft, or vandalism. If you choose to have it, we assume it costs 1.32% of your monthly rent.',
  },
  BUYING_COSTS: {
    label: 'Buying closing costs',
    tooltip:
      'Closing costs for the buyer include lender fees, appraisals, inspections, and other costs. We estimated it as a percentage of the home purchase price.',
  },
  SELLING_COSTS: {
    label: 'Selling closing costs',
    tooltip:
      'Closing costs when you sell your home include any type of agent commission. We estimated it as a percentage of the home sale price.',
  },
  RENT_SECURITY_DEPOSIT: {
    label: 'Rent security deposit',
    tooltip:
      'Rental deposit, returned upon move out. Provide this as a number of months of rent.',
  },
  HOME_APPRECIATION: {
    label: 'Home value appreciation',
    tooltip:
      'The rate at which you expect the home value to grow after buying.',
  },
  RENT_APPRECIATION: {
    label: 'Rent appreciation',
    tooltip: 'The rate at which your rent is likely to increase each year.',
  },
  GENERAL_INFLATION: {
    label: 'General inflation',
    tooltip:
      'Impacts costs such as maintenance and renovation costs, which we assume increase at the rate of inflation.',
  },
  ANNUAL_RETURN_CASH: {
    label: 'Annual return on cash (after tax)',
    tooltip:
      'How much you earn per year from any money you save in a bank, stocks, bonds, or other form of investment.',
  },
  TAX_FILING_STATUS: {
    label: 'Tax filing status',
    tooltip:
      'The tax implications of buying and selling a home will depend on your federal tax filing status.',
  },
  INCOME: {
    label: 'Household income',
    tooltip:
      'This is used to factor in your tax savings from paying interest, property taxes, and private mortgage insurance (PMI).',
  },
  CAPITAL_GAINS_TAX_RATE: {
    label: 'Capital gains tax rate',
    tooltip:
      'We assume that the profit you would have made in your investments would be taxed as long-term capital gains.',
  },
};
